import React from "react";
import { ROUTES } from "../../config/routes";

export interface PublicRouteProps {
  children: React.ReactElement;
  redirectTo?: string;
  userTypeRedirect?: string;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children, redirectTo = ROUTES.HOME }) => {
  void redirectTo;
  return children;
};

export default PublicRoute;
